/**
 * The two query parameters the organization admin panel carries its state in —
 * `/clarity/organization?org_id=<id>&tab=<tab>`.
 *
 * The names are brain's own (`useSelectedOrg.ts`, `OrgAdminContent.tsx`, `billingAlertService.js`)
 * and are kept verbatim, so a link minted by either product opens the same panel on the same
 * organization and the same tab.
 *
 * Shared for the same reason {@link CLARITY_ORGANIZATION_ROUTE_SEGMENT} is: the panel's page reads
 * both back and the chat's billing link writes them, from two libraries that only meet at
 * `type:util`. A drift between writer and reader fails silently rather than loudly — a link whose
 * parameter the page never reads still matches the route and still renders, landing on the panel's
 * default organization and default tab with no error anywhere.
 */
export const CLARITY_ORGANIZATION_QUERY_PARAM = {
	/** The organization the panel is scoped to. */
	ORG_ID: 'org_id',

	/** The panel tab to open. */
	TAB: 'tab',
} as const;
